export default {"src":"/_next/static/media/logo.39390f84.svg","height":36,"width":140};